import { createContext as t, createElement as e, PureComponent as o, Children as r, cloneElement as n, createRef as i } from "react";
import { createPortal as a } from "react-dom";

function s(t, e, o) {
  return e in t ? Object.defineProperty(t, e, {
    value: o,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[e] = o, t;
}

function u() {
  return (u = Object.assign || function (t) {
    for (var e = 1; e < arguments.length; e++) {
      var o = arguments[e];

      for (var r in o) {
        Object.prototype.hasOwnProperty.call(o, r) && (t[r] = o[r]);
      }
    }

    return t;
  }).apply(this, arguments);
}

function p(t, e) {
  t.prototype = Object.create(e.prototype), t.prototype.constructor = t, t.__proto__ = e;
}

function l(t, e) {
  if (null == t) return {};
  var o,
      r,
      n = {},
      i = Object.keys(t);

  for (r = 0; r < i.length; r++) {
    o = i[r], e.indexOf(o) >= 0 || (n[o] = t[o]);
  }

  return n;
}

function c(t) {
  if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}

function d(t) {
  return function (t) {
    if (Array.isArray(t)) {
      for (var e = 0, o = new Array(t.length); e < t.length; e++) {
        o[e] = t[e];
      }

      return o;
    }
  }(t) || function (t) {
    if (Symbol.iterator in Object(t) || "[object Arguments]" === Object.prototype.toString.call(t)) return Array.from(t);
  }(t) || function () {
    throw new TypeError("Invalid attempt to spread non-iterable instance");
  }();
}

var h = t(null),
    m = !("[object process]" === Object.prototype.toString.call(global.process) && !global.process.browser) ? require("mapbox-gl") : null,
    f = ["resize", "remove", "mousedown", "mouseup", "mouseover", "mousemove", "click", "dblclick", "mouseenter", "mouseleave", "mouseout", "contextmenu", "touchstart", "touchend", "touchmove", "touchcancel", "movestart", "move", "moveend", "dragstart", "drag", "dragend", "zoomstart", "zoom", "zoomend", "rotatestart", "rotate", "rotateend", "pitchstart", "pitch", "pitchend", "boxzoomstart", "boxzoomend", "boxzoomcancel", "webglcontextlost", "webglcontextrestored", "load", "error", "data", "styledata", "sourcedata", "dataloading", "styledataloading", "sourcedataloading"],
    g = function g(t, e) {
  void 0 === t && (t = {}), void 0 === e && (e = {});
  var o = new Set([].concat(d(Object.keys(t)), d(Object.keys(e))));
  return d(o).reduce(function (o, r) {
    var n = t[r];
    return n !== e[r] && o.push([r, n]), o;
  }, []);
},
    _ = function _(t, e, o, r) {
  var n = {
    layers: [e]
  };

  if (r) {
    var i = [[o[0] - r, o[1] - r], [o[0] + r, o[1] + r]];
    return t.queryRenderedFeatures(i, n);
  }

  return t.queryRenderedFeatures(o, n);
},
    v = [["onClick", "click"], ["onHover", "mousemove"], ["onEnter", "mouseenter"], ["onLeave", "mouseleave"]],
    y = function (t) {
  function o(e) {
    var o;
    return s(c(o = t.call(this, e) || this), "$key", void 0), s(c(o), "$value", void 0), s(c(o), "_id", void 0), s(c(o), "_map", void 0), s(c(o), "_onClick", void 0), s(c(o), "_onHover", void 0), s(c(o), "_onEnter", void 0), s(c(o), "_onLeave", void 0), s(c(o), "_onClick", function (t) {
      var e = [t.point.x, t.point.y],
          r = _(o._map, o._id, e, o.props.radius);

      o.props.onClick(u({}, t, {
        features: r
      }));
    }), s(c(o), "_onHover", function (t) {
      var e = [t.point.x, t.point.y],
          r = _(o._map, o._id, e, o.props.radius);

      o.props.onHover(u({}, t, {
        features: r
      }));
    }), s(c(o), "_onEnter", function (t) {
      var e = [t.point.x, t.point.y],
          r = _(o._map, o._id, e, o.props.radius);

      o.props.onEnter(u({}, t, {
        features: r
      }));
    }), s(c(o), "_onLeave", function (t) {
      var e = [t.point.x, t.point.y],
          r = _(o._map, o._id, e, o.props.radius);

      o.props.onLeave(u({}, t, {
        features: r
      }));
    }), o._id = e.id, o;
  }

  p(o, t);
  var r = o.prototype;
  return r.componentDidMount = function () {
    var t = this._map,
        e = this.props,
        o = e.before,
        r = (e.radius, e.onClick),
        n = e.onHover,
        i = e.onEnter,
        a = e.onLeave,
        s = l(e, ["before", "radius", "onClick", "onHover", "onEnter", "onLeave"]);
    o && t.getLayer(o) ? t.addLayer(s, o) : t.addLayer(s), r && t.on("click", this._id, this._onClick), n && t.on("mousemove", this._id, this._onHover), i && t.on("mouseenter", this._id, this._onEnter), a && t.on("mouseleave", this._id, this._onLeave);
  }, r.componentDidUpdate = function (t) {
    var e = this,
        o = this._map,
        r = this.props,
        n = r.before,
        i = (r.onClick, l(r, ["before", "onClick"]));
    n !== t.before && o.moveLayer(i.id, n), i.paint !== t.paint && g(i.paint, t.paint).forEach(function (t) {
      var r = t[0],
          n = t[1];
      o.setPaintProperty(e._id, r, n);
    }), i.layout !== t.layout && g(i.layout, t.layout).forEach(function (t) {
      var r = t[0],
          n = t[1];
      o.setLayoutProperty(e._id, r, n);
    }), i.filter !== t.filter && (i.filter ? o.setFilter(this._id, i.filter) : o.setFilter(this._id, void 0)), v.forEach(function (r) {
      var n = r[0],
          i = r[1],
          a = "_" + n;
      !e.props[n] && t[n] && o.off(i, e._id, e[a]), e.props[n] && !t[n] && o.on(i, e._id, e[a]);
    });
  }, r.componentWillUnmount = function () {
    var t = this;
    this._map && this._map.getStyle() && this._map.getLayer(this._id) && (v.forEach(function (e) {
      var o = e[0],
          r = e[1],
          n = "_" + o;
      t.props[o] && t._map.off(r, t._id, t[n]);
    }), this._map.removeLayer(this._id));
  }, r.render = function () {
    var t = this;
    return e(h.Consumer, {}, function (e) {
      return e && (t._map = e), null;
    });
  }, o;
}(o);

s(y, "displayName", "Layer"), s(y, "defaultProps", {
  radius: 0
});

var b = function (t) {
  function o() {
    for (var e, o = arguments.length, r = new Array(o), n = 0; n < o; n++) {
      r[n] = arguments[n];
    }

    return s(c(e = t.call.apply(t, [this].concat(r)) || this), "_id", void 0), s(c(e), "_map", void 0), e;
  }

  p(o, t);
  var r = o.prototype;
  return r.componentDidMount = function () {
    var t = this.props,
        e = t.layer,
        o = t.before;
    o && this._map.getLayer(o) ? this._map.addLayer(e, o) : this._map.addLayer(e), this._id = e.id;
  }, r.componentWillUnmount = function () {
    this._map && this._map.getStyle() && this._map.getLayer(this._id) && this._map.removeLayer(this._id);
  }, r.render = function () {
    var t = this;
    return e(h.Consumer, {}, function (e) {
      return e && (t._map = e), null;
    });
  }, o;
}(o);

s(b, "displayName", "CustomLayer");

var L = function L(t) {
  return r.toArray(t).filter(Boolean).reduce(function (t, e, o) {
    var r = t.previousLayerIndex;

    if (e.type === y || e.type === b) {
      if (r) {
        var i = function (t) {
          return t.type === b ? t.props.layer.id : t.props.id;
        }(e),
            a = t.children[r],
            s = a.props.before || i,
            u = n(a, {
          before: s
        });

        t.children[r] = u;
      }

      t.previousLayerIndex = o;
    }

    return t.children.push(e), t;
  }, {
    children: [],
    previousLayerIndex: void 0
  }).children;
};

var C = function C(t) {
  return t.charAt(0).toUpperCase() + t.slice(1);
},
    S = function (t) {
  function o(e) {
    var o;
    return s(c(o = t.call(this, e) || this), "_map", void 0), s(c(o), "_container", void 0), s(c(o), "_onViewportChange", void 0), s(c(o), "state", {
      loaded: !1
    }), s(c(o), "_onViewportChange", function (t) {
      if (t.originalEvent) {
        var e = o._map,
            r = e.getCenter(),
            n = r.lng,
            i = {
          latitude: r.lat,
          longitude: n,
          zoom: e.getZoom(),
          pitch: e.getPitch(),
          bearing: e.getBearing()
        };
        o.props.onViewportChange(i);
      }
    }), m && (m.accessToken = e.accessToken), o._container = i(), o;
  }

  p(o, t);
  var r = o.prototype;
  return r.componentDidMount = function () {
    var t = this;

    if (m) {
      var e = this._container.current,
          o = new m.Map({
        container: e,
        style: this.props.mapStyle,
        interactive: !!this.props.onViewportChange,
        center: [this.props.longitude, this.props.latitude],
        zoom: this.props.zoom,
        pitch: this.props.pitch,
        bearing: this.props.bearing,
        minZoom: this.props.minZoom,
        maxZoom: this.props.maxZoom,
        hash: this.props.hash,
        bearingSnap: this.props.bearingSnap,
        pitchWithRotate: this.props.pitchWithRotate,
        attributionControl: this.props.attributionControl,
        logoPosition: this.props.logoPosition,
        failIfMajorPerformanceCaveat: this.props.failIfMajorPerformanceCaveat,
        preserveDrawingBuffer: this.props.preserveDrawingBuffer,
        refreshExpiredTiles: this.props.refreshExpiredTiles,
        maxBounds: this.props.maxBounds,
        scrollZoom: this.props.scrollZoom,
        boxZoom: this.props.boxZoom,
        dragRotate: this.props.dragRotate,
        dragPan: this.props.dragPan,
        keyboard: this.props.keyboard,
        doubleClickZoom: this.props.doubleClickZoom,
        trackResize: this.props.trackResize,
        renderWorldCopies: this.props.renderWorldCopies,
        maxTileCacheSize: this.props.maxTileCacheSize,
        localIdeographFontFamily: this.props.localIdeographFontFamily,
        transformRequest: this.props.transformRequest,
        collectResourceTiming: this.props.collectResourceTiming
      });
      this._map = o, o.on("styledata", function () {
        return t.setState({
          loaded: !0
        });
      }), o.once("load", function () {
        t.setState({
          loaded: !0
        }, t.props.onLoad);
      }), this.props.onViewportChange && (o.on("dragend", this._onViewportChange), o.on("zoomend", this._onViewportChange), o.on("rotateend", this._onViewportChange), o.on("pitchend", this._onViewportChange), o.on("boxzoomend", this._onViewportChange)), f.forEach(function (e) {
        var r = "on" + C(e);
        t.props[r] && o.on(e, t.props[r]);
      }), this.props.cursorStyle && (o.getCanvas().style.cursor = this.props.cursorStyle);
    }
  }, r.componentDidUpdate = function (t) {
    this._updateMapViewport(t, this.props), this._updateMapStyle(t, this.props), !t.cursorStyle !== this.props.cursorStyle && (this._map.getCanvas().style.cursor = this.props.cursorStyle);
  }, r.componentWillUnmount = function () {
    this._map && this._map.remove();
  }, r.getMap = function () {
    return this._map;
  }, r._updateMapStyle = function (t, e) {
    var o = this,
        r = e.mapStyle,
        n = t.mapStyle;
    r !== n && this.setState({
      loaded: !1
    }, function () {
      return o._map.setStyle(r);
    });
  }, r._updateMapViewport = function (t, e) {
    var o = this._map,
        r = o.getCenter();

    if (e.latitude !== t.latitude && e.latitude !== r.lat || e.longitude !== t.longitude && e.longitude !== r.lng || e.zoom !== t.zoom && e.zoom !== o.getZoom() || e.pitch !== t.pitch && e.pitch !== o.getPitch() || e.bearing !== t.bearing && e.bearing !== o.getBearing()) {
      var n = {
        center: [e.longitude, e.latitude],
        zoom: e.zoom,
        pitch: e.pitch,
        bearing: e.bearing
      },
          i = this.props,
          a = i.viewportChangeMethod,
          s = u({}, i.viewportChangeOptions, n);

      switch (a) {
        case "flyTo":
          o.flyTo(s);
          break;

        case "jumpTo":
          o.jumpTo(s);
          break;

        case "easeTo":
          o.easeTo(s);
          break;

        default:
          throw new Error("Unknown viewport change method");
      }
    }
  }, r.render = function () {
    var t = this.state.loaded,
        o = this.props,
        r = o.className,
        n = o.style,
        i = this.props.children ? L(this.props.children) : null;
    return e(h.Provider, {
      value: this._map
    }, e("div", {
      ref: this._container,
      style: n,
      className: r
    }, t && i));
  }, o;
}(o);

s(S, "displayName", "MapGL"), s(S, "defaultProps", {
  children: null,
  className: null,
  style: null,
  mapStyle: "mapbox://styles/mapbox/light-v8",
  accessToken: null,
  bearing: 0,
  pitch: 0,
  minZoom: 0,
  maxZoom: 22,
  maxBounds: null,
  hash: !1,
  bearingSnap: 7,
  pitchWithRotate: !0,
  attributionControl: !0,
  logoPosition: "bottom-left",
  failIfMajorPerformanceCaveat: !1,
  preserveDrawingBuffer: !1,
  refreshExpiredTiles: !0,
  boxZoom: !0,
  scrollZoom: !0,
  dragRotate: !0,
  dragPan: !0,
  keyboard: !0,
  doubleClickZoom: !0,
  trackResize: !0,
  renderWorldCopies: !0,
  maxTileCacheSize: null,
  onViewportChange: null,
  onLoad: null,
  localIdeographFontFamily: null,
  transformRequest: null,
  collectResourceTiming: !1,
  cursorStyle: null,
  viewportChangeMethod: "jumpTo",
  viewportChangeOptions: null
});

var w = function w(t) {
  switch (t.type) {
    case "vector":
      return u({
        type: "vector"
      }, t);

    case "raster":
      return u({
        type: "raster"
      }, t);

    case "raster-dem":
      return u({
        type: "raster-dem"
      }, t);

    case "geojson":
      return u({
        type: "geojson"
      }, t);

    case "video":
      return u({
        type: "video"
      }, t);

    case "image":
      return u({
        type: "image"
      }, t);

    default:
      throw new Error("Unknown type for '" + t.id + "' Source");
  }
},
    k = function (t) {
  function o() {
    for (var e, o = arguments.length, r = new Array(o), n = 0; n < o; n++) {
      r[n] = arguments[n];
    }

    return s(c(e = t.call.apply(t, [this].concat(r)) || this), "_map", void 0), s(c(e), "state", {
      loaded: !1
    }), s(c(e), "_onSourceData", function () {
      e._map.isSourceLoaded(e.props.id) && (e._map.off("sourcedata", e._onSourceData), e.setState({
        loaded: !0
      }));
    }), s(c(e), "_updateGeoJSONSource", function (t, o, r) {
      r.data !== o.data && e._map.getSource(t).setData(r.data);
    }), s(c(e), "_updateVectorSource", function (t, o, r) {
      var n = e._map.getSource(t);

      n._tileJSONRequest && n._tileJSONRequest.cancel(), n.url = r.url, n.scheme = r.scheme, n._options = u({}, n._options, r);
      var i = e._map.style.sourceCaches[t];
      i && i.clearTiles(), n.load();
    }), s(c(e), "_removeSource", function () {
      var t = e.props.id;

      if (e._map.getSource(t)) {
        var o = e._map.getStyle().layers;

        o && o.forEach(function (o) {
          o.source === t && e._map.removeLayer(o.id);
        }), e._map.removeSource(t);
      }
    }), e;
  }

  p(o, t);
  var r = o.prototype;
  return r.componentDidMount = function () {
    var t = w(this.props),
        e = t.id,
        o = (t.children, l(t, ["id", "children"]));
    this._map.addSource(e, o), this._map.on("sourcedata", this._onSourceData);
  }, r.componentDidUpdate = function (t) {
    var e = w(t),
        o = e.id,
        r = (e.children, l(e, ["id", "children"])),
        n = w(this.props),
        i = n.id,
        a = (n.children, l(n, ["id", "children"]));
    if (i !== o || a.type !== r.type) return this._map.removeSource(o), void this._map.addSource(i, a);
    "geojson" !== a.type || "geojson" !== r.type ? "vector" === a.type && "vector" === r.type && this._updateVectorSource(i, r, a) : this._updateGeoJSONSource(i, r, a);
  }, r.componentWillUnmount = function () {
    this._map && this._map.getStyle() && this._removeSource();
  }, r.render = function () {
    var t = this,
        o = this.state.loaded,
        r = this.props.children ? L(this.props.children) : null;
    return e(h.Consumer, {}, function (e) {
      return e && (t._map = e), o && r;
    });
  }, o;
}(o);

s(k, "displayName", "Source");

var x = function (t) {
  function o(e) {
    var o;
    return s(c(o = t.call(this, e) || this), "_map", void 0), s(c(o), "_el", void 0), s(c(o), "_popup", void 0), o._el = document.createElement("div"), o;
  }

  p(o, t);
  var r = o.prototype;
  return r.componentDidMount = function () {
    var t = this.props,
        e = t.longitude,
        o = t.latitude,
        r = t.offset,
        n = t.closeButton,
        i = t.closeOnClick,
        a = t.onClose,
        s = t.anchor;
    this._popup = new m.Popup({
      offset: r,
      closeButton: n,
      closeOnClick: i,
      anchor: s
    }), this._popup.setDOMContent(this._el), this._popup.setLngLat([e, o]).addTo(this._map), a && this._popup.on("close", a);
  }, r.componentDidUpdate = function (t) {
    (t.latitude !== this.props.latitude || t.longitude !== this.props.longitude) && this._popup.setLngLat([this.props.longitude, this.props.latitude]);
  }, r.componentWillUnmount = function () {
    this._map && this._map.getStyle() && this._popup.remove();
  }, r.getPopup = function () {
    return this._popup;
  }, r.render = function () {
    var t = this;
    return e(h.Consumer, {}, function (e) {
      return e && (t._map = e), a(t.props.children, t._el);
    });
  }, o;
}(o);

s(x, "displayName", "Popup"), s(x, "defaultProps", {
  closeButton: !0,
  closeOnClick: !0,
  onClose: null,
  anchor: null,
  offset: null
});

var O = function (t) {
  function o(e) {
    var o;
    return s(c(o = t.call(this, e) || this), "_map", void 0), s(c(o), "_el", void 0), s(c(o), "_marker", void 0), s(c(o), "_onDragEnd", function () {
      o.props.onDragEnd(o._marker.getLngLat());
    }), s(c(o), "_onDragStart", function () {
      o.props.onDragStart(o._marker.getLngLat());
    }), s(c(o), "_onDrag", function () {
      o.props.onDrag(o._marker.getLngLat());
    }), o._el = document.createElement("div"), o;
  }

  p(o, t);
  var r = o.prototype;
  return r.componentDidMount = function () {
    var t = this.props,
        e = t.longitude,
        o = t.latitude,
        r = t.offset,
        n = t.draggable,
        i = t.onDragEnd,
        a = t.onDragStart,
        s = t.onDrag;
    this._marker = new m.Marker(this._el, {
      draggable: n,
      offset: r
    }), this._marker.setLngLat([e, o]).addTo(this._map), i && this._marker.on("dragend", this._onDragEnd), a && this._marker.on("dragstart", this._onDragStart), s && this._marker.on("drag", this._onDrag);
  }, r.componentDidUpdate = function (t) {
    (t.latitude !== this.props.latitude || t.longitude !== this.props.longitude) && this._marker.setLngLat([this.props.longitude, this.props.latitude]);
  }, r.componentWillUnmount = function () {
    this._map && this._map.getStyle() && this._marker.remove();
  }, r.getMarker = function () {
    return this._marker;
  }, r.render = function () {
    var t = this;
    return e(h.Consumer, {}, function (e) {
      return e && (t._map = e), a(t.props.children, t._el);
    });
  }, o;
}(o);

s(O, "displayName", "Marker"), s(O, "defaultProps", {
  offset: null,
  draggable: !1
});

var D = function (t) {
  function o() {
    for (var e, o = arguments.length, r = new Array(o), n = 0; n < o; n++) {
      r[n] = arguments[n];
    }

    return s(c(e = t.call.apply(t, [this].concat(r)) || this), "_map", void 0), e;
  }

  p(o, t);
  var r = o.prototype;
  return r.componentDidMount = function () {
    var t = this._map,
        e = this.props,
        o = e.id,
        r = e.source,
        n = e.sourceLayer,
        i = e.state;
    t.setFeatureState({
      id: o,
      source: r,
      sourceLayer: n
    }, i);
  }, r.componentDidUpdate = function (t) {
    var e = this._map,
        o = this.props,
        r = o.id,
        n = o.source,
        i = o.sourceLayer,
        a = o.state;
    r === t.id && n === t.source && i === t.sourceLayer && a === t.state || (e.removeFeatureState({
      id: t.id,
      source: t.source,
      sourceLayer: t.sourceLayer
    }), e.setFeatureState({
      id: r,
      source: n,
      sourceLayer: i
    }, a));
  }, r.componentWillUnmount = function () {
    if (this._map && this._map.getStyle()) {
      var t = this.props,
          e = t.id,
          o = t.source,
          r = t.sourceLayer;

      this._map.removeFeatureState({
        id: e,
        source: o,
        sourceLayer: r
      });
    }
  }, r.render = function () {
    var t = this;
    return e(h.Consumer, {}, function (e) {
      return e && (t._map = e), null;
    });
  }, o;
}(o),
    U = function (t) {
  function o() {
    for (var e, o = arguments.length, r = new Array(o), n = 0; n < o; n++) {
      r[n] = arguments[n];
    }

    return s(c(e = t.call.apply(t, [this].concat(r)) || this), "_map", void 0), s(c(e), "_control", void 0), e;
  }

  p(o, t);
  var r = o.prototype;
  return r.componentDidMount = function () {
    var t = this._map,
        e = this.props,
        o = e.compact,
        r = e.customAttribution,
        n = e.position,
        i = new m.AttributionControl({
      compact: o,
      customAttribution: r
    });
    t.addControl(i, n), this._control = i;
  }, r.componentWillUnmount = function () {
    this._map && this._map.getStyle() && this._map.removeControl(this._control);
  }, r.getControl = function () {
    return this._control;
  }, r.render = function () {
    var t = this;
    return e(h.Consumer, {}, function (e) {
      return e && (t._map = e), null;
    });
  }, o;
}(o);

s(U, "defaultProps", {
  position: "bottom-right"
});

var j = function (t) {
  function o() {
    for (var e, o = arguments.length, r = new Array(o), n = 0; n < o; n++) {
      r[n] = arguments[n];
    }

    return s(c(e = t.call.apply(t, [this].concat(r)) || this), "_map", void 0), s(c(e), "_control", void 0), e;
  }

  p(o, t);
  var r = o.prototype;
  return r.componentDidMount = function () {
    var t = this._map,
        e = this.props,
        o = e.container,
        r = e.position,
        n = new m.FullscreenControl({
      container: o
    });
    t.addControl(n, r), this._control = n;
  }, r.componentWillUnmount = function () {
    this._map && this._map.getStyle() && this._map.removeControl(this._control);
  }, r.getControl = function () {
    return this._control;
  }, r.render = function () {
    var t = this;
    return e(h.Consumer, {}, function (e) {
      return e && (t._map = e), null;
    });
  }, o;
}(o);

s(j, "defaultProps", {
  position: "top-right"
});

var E = function (t) {
  function o() {
    for (var e, o = arguments.length, r = new Array(o), n = 0; n < o; n++) {
      r[n] = arguments[n];
    }

    return s(c(e = t.call.apply(t, [this].concat(r)) || this), "_map", void 0), s(c(e), "_control", void 0), e;
  }

  p(o, t);
  var r = o.prototype;
  return r.componentDidMount = function () {
    var t = this._map,
        e = this.props,
        o = e.positionOptions,
        r = e.fitBoundsOptions,
        n = e.trackUserLocation,
        i = e.showUserLocation,
        a = e.position,
        s = e.onTrackUserLocationEnd,
        u = e.onTrackUserLocationStart,
        p = e.onError,
        l = e.onGeolocate,
        c = new m.GeolocateControl({
      positionOptions: o,
      fitBoundsOptions: r,
      trackUserLocation: n,
      showUserLocation: i
    });
    s && c.on("trackuserlocationend", s), u && c.on("trackuserlocationstart", u), p && c.on("error", p), l && c.on("geolocate", l), t.addControl(c, a), this._control = c;
  }, r.componentWillUnmount = function () {
    this._map && this._map.getStyle() && this._map.removeControl(this._control);
  }, r.getControl = function () {
    return this._control;
  }, r.render = function () {
    var t = this;
    return e(h.Consumer, {}, function (e) {
      return e && (t._map = e), null;
    });
  }, o;
}(o);

s(E, "defaultProps", {
  positionOptions: {
    enableHighAccuracy: !1,
    timeout: 6e3
  },
  fitBoundsOptions: {
    maxZoom: 15
  },
  trackUserLocation: !1,
  showUserLocation: !0
});

var M = function (t) {
  function o() {
    for (var e, o = arguments.length, r = new Array(o), n = 0; n < o; n++) {
      r[n] = arguments[n];
    }

    return s(c(e = t.call.apply(t, [this].concat(r)) || this), "_map", void 0), s(c(e), "_control", void 0), e;
  }

  p(o, t);
  var r = o.prototype;
  return r.componentDidMount = function () {
    var t = this._map,
        e = this.props,
        o = e.showCompass,
        r = e.showZoom,
        n = e.position,
        i = new m.NavigationControl({
      showCompass: o,
      showZoom: r
    });
    t.addControl(i, n), this._control = i;
  }, r.componentWillUnmount = function () {
    this._map && this._map.getStyle() && this._map.removeControl(this._control);
  }, r.getControl = function () {
    return this._control;
  }, r.render = function () {
    var t = this;
    return e(h.Consumer, {}, function (e) {
      return e && (t._map = e), null;
    });
  }, o;
}(o);

s(M, "defaultProps", {
  position: "top-right"
});

var P = function (t) {
  function o() {
    for (var e, o = arguments.length, r = new Array(o), n = 0; n < o; n++) {
      r[n] = arguments[n];
    }

    return s(c(e = t.call.apply(t, [this].concat(r)) || this), "_map", void 0), s(c(e), "_control", void 0), e;
  }

  p(o, t);
  var r = o.prototype;
  return r.componentDidMount = function () {
    var t = this._map,
        e = this.props,
        o = e.maxWidth,
        r = e.unit,
        n = e.position,
        i = new m.ScaleControl({
      maxWidth: o,
      unit: r
    });
    t.addControl(i, n), this._control = i;
  }, r.componentWillUnmount = function () {
    this._map && this._map.getStyle() && this._map.removeControl(this._control);
  }, r.getControl = function () {
    return this._control;
  }, r.render = function () {
    var t = this;
    return e(h.Consumer, {}, function (e) {
      return e && (t._map = e), null;
    });
  }, o;
}(o);

s(P, "defaultProps", {
  position: "bottom-right",
  unit: "metric"
});

var T,
    F = (function (t) {
  function e(t) {
    if (t = Object.assign({}, t), !(this instanceof e)) throw new Error("MapboxLanguage needs to be called with the new keyword");
    this.setLanguage = this.setLanguage.bind(this), this._initialStyleUpdate = this._initialStyleUpdate.bind(this), this._defaultLanguage = t.defaultLanguage, this._isLanguageField = t.languageField || /^\{name/, this._getLanguageField = t.getLanguageField || function (t) {
      return "mul" === t ? "{name}" : "{name_" + t + "}";
    }, this._languageSource = t.languageSource || null, this._languageTransform = t.languageTransform || function (t, e) {
      return "ar" === e ? function (t) {
        var e = t.layers.map(function (t) {
          if (!(t.layout || {})["text-field"]) return t;
          return Object.assign({}, t, {
            layout: Object.assign({}, t.layout, {
              "text-letter-spacing": 0
            })
          });
        });
        return Object.assign({}, t, {
          layers: e
        });
      }(t) : function (t) {
        var e = t.layers.map(function (t) {
          if (!(t.layout || {})["text-field"]) return t;
          var e = 0;
          return "state_label" === t["source-layer"] && (e = .15), "marine_label" === t["source-layer"] && (/-lg/.test(t.id) && (e = .25), /-md/.test(t.id) && (e = .15), /-sm/.test(t.id) && (e = .1)), "place_label" === t["source-layer"] && (/-suburb/.test(t.id) && (e = .15), /-neighbour/.test(t.id) && (e = .1), /-islet/.test(t.id) && (e = .01)), "airport_label" === t["source-layer"] && (e = .01), "rail_station_label" === t["source-layer"] && (e = .01), "poi_label" === t["source-layer"] && /-scalerank/.test(t.id) && (e = .01), "road_label" === t["source-layer"] && (/-label-/.test(t.id) && (e = .01), /-shields/.test(t.id) && (e = .05)), Object.assign({}, t, {
            layout: Object.assign({}, t.layout, {
              "text-letter-spacing": e
            })
          });
        });
        return Object.assign({}, t, {
          layers: e
        });
      }(t);
    }, this._excludedLayerIds = t.excludedLayerIds || [], this.supportedLanguages = t.supportedLanguages || ["ar", "en", "es", "fr", "de", "ja", "ko", "mul", "pt", "ru", "zh"];
  }

  function o(t, e, o) {
    if (function (t, e) {
      return "string" == typeof e && t.test(e);
    }(t, e)) return o;

    if (function (t, e) {
      return e.stops && e.stops.filter(function (e) {
        return t.test(e[1]);
      }).length > 0;
    }(t, e)) {
      var r = e.stops.map(function (e) {
        return t.test(e[1]) ? [e[0], o] : e;
      });
      return Object.assign({}, e, {
        stops: r
      });
    }

    return e;
  }

  e.prototype.setLanguage = function (t, e) {
    if (this.supportedLanguages.indexOf(e) < 0) throw new Error("Language " + e + " is not supported");

    var r = this._languageSource || function (t) {
      return Object.keys(t.sources).filter(function (e) {
        var o = t.sources[e];
        return /mapbox-streets-v\d/.test(o.url);
      })[0];
    }(t);

    if (!r) return t;

    var n = this._getLanguageField(e),
        i = this._isLanguageField,
        a = this._excludedLayerIds,
        s = t.layers.map(function (t) {
      return t.source === r ? function (t, e, r, n) {
        return e.layout && e.layout["text-field"] && -1 === n.indexOf(e.id) ? Object.assign({}, e, {
          layout: Object.assign({}, e.layout, {
            "text-field": o(t, e.layout["text-field"], r)
          })
        }) : e;
      }(i, t, n, a) : t;
    }),
        u = Object.assign({}, t, {
      layers: s
    });

    return this._languageTransform(u, e);
  }, e.prototype._initialStyleUpdate = function () {
    var t = this._map.getStyle(),
        e = this._defaultLanguage || function (t) {
      var e = navigator.languages ? navigator.languages[0] : navigator.language || navigator.userLanguage,
          o = e.split("-"),
          r = e;
      o.length > 1 && (r = o[0]);
      if (t.indexOf(r) > -1) return r;
      return null;
    }(this.supportedLanguages);

    this._map.off("styledata", this._initialStyleUpdate), this._map.setStyle(this.setLanguage(t, e));
  }, e.prototype.onAdd = function (t) {
    return this._map = t, this._map.on("styledata", this._initialStyleUpdate), this._container = document.createElement("div"), this._container;
  }, e.prototype.onRemove = function () {
    this._map.off("styledata", this._initialStyleUpdate), this._map = void 0;
  }, t.exports = e;
}(T = {
  exports: {}
}, T.exports), T.exports),
    z = function (t) {
  function o() {
    for (var e, o = arguments.length, r = new Array(o), n = 0; n < o; n++) {
      r[n] = arguments[n];
    }

    return s(c(e = t.call.apply(t, [this].concat(r)) || this), "_map", void 0), s(c(e), "_control", void 0), s(c(e), "_setLanguage", function () {
      var t = e.props.language,
          o = e._map,
          r = e._control;
      t && o.setStyle(r.setLanguage(o.getStyle(), t));
    }), e;
  }

  p(o, t);
  var r = o.prototype;
  return r.componentDidMount = function () {
    var t = this._map,
        e = this.props,
        o = e.supportedLanguages,
        r = e.languageTransform,
        n = e.languageField,
        i = e.getLanguageField,
        a = e.languageSource,
        s = e.defaultLanguage,
        u = new F({
      supportedLanguages: o,
      languageTransform: r,
      languageField: n,
      getLanguageField: i,
      languageSource: a,
      defaultLanguage: s
    });
    t.addControl(u), this._control = u;
  }, r.componentDidUpdate = function (t) {
    t.language !== this.props.language && this._setLanguage();
  }, r.componentWillUnmount = function () {
    this._map && this._map.getStyle() && this._map.removeControl(this._control);
  }, r.getControl = function () {
    return this._control;
  }, r.render = function () {
    var t = this;
    return e(h.Consumer, {}, function (e) {
      return e && (t._map = e), null;
    });
  }, o;
}(o);

s(z, "defaultProps", {});
export default S;
export { U as AttributionControl, b as CustomLayer, D as FeatureState, j as FullscreenControl, E as GeolocateControl, z as LanguageControl, y as Layer, h as MapContext, O as Marker, M as NavigationControl, x as Popup, P as ScaleControl, k as Source };